(ns frontend.ui.component.lp-portal.report.tearsheet.portfolio-locations.style)

(defn card
  []
  {:padding 0})

(defn footnote-container
  []
  {:padding "1rem"})
